import * as Sentry from '@sentry/browser';

export function initSentryTracking() {
  Sentry.init({
    dsn: 'https://131f7d1bec75fa9f56d0ec934f6a9f0b@o4505796784095232.ingest.us.sentry.io/4510779082604544',
    sendDefaultPii: true,
  });
}

export function captureSentryMessage(message, level = 'error', extra = {}) {
  Sentry.captureMessage(message, {
    level,
    extra,
  });
}
